import Multiselect from 'multiselect-react-dropdown'
import React, { useEffect, useState } from 'react'
import NumberFormat from 'react-number-format'
import { validateFunctionalForm } from '../../utils'
import { jobQuestionList } from '../../action/jobs'
import moment from 'moment'

const StepTwo = ({ styles, detail, prevStep, onSubmit, oppurtunityType }) => {
    const [state, setState] = useState({
        include_walk_in_distance: false,
        walk_in_start_date: {
            name: "WALK_IN_START_DATE",
            value: detail ? detail.WALK_IN_START_DATE : "",
            options: [],
            error: "",
            isRequired: false,
        },
        walk_in_start_time: {
            name: "WALK_IN_START_TIME",
            value: detail ? detail.WALK_IN_START_TIME : "",
            options: [],
            error: "",
            isRequired: false,
        },
        walk_in_end_time: {
            name: "WALK_IN_END_TIME",
            value: detail ? detail.WALK_IN_END_TIME : "",
            options: [],
            error: "",
            isRequired: false,
        },
        duration: {
            name: "DURATION",
            value: detail ? detail.DURATION : "",
            options: [],
            error: "",
            isRequired: false,
        },
        contact_person: {
            name: "CONTACT_PERSON",
            value: detail ? detail.CONTACT_PERSON : "",
            options: [],
            error: "",
            isRequired: false,
        },
        mobile_number: {
            name: "MOBILE_NUMBER",
            value: detail ? detail.MOBILE_NUMBER : "",
            options: [],
            error: "",
            isRequired: false,
        },
        venue: {
            name: "VENUE",
            value: detail ? detail.VENUE : "",
            options: [],
            error: "",
            isRequired: false,
        },
        google_map_url: {
            name: "GOOGLE_MAP_URL",
            value: detail ? detail.GOOGLE_MAP_URL : "",
            options: [],
            error: "",
            isRequired: false,
        },
        company_name: {
            name: "COMPANY_NAME",
            value: detail ? detail.COMPANY_NAME : "",
            options: [],
            error: "",
            isRequired: false,
        },
        selected_questions: detail ? detail.QUESTION_ID.map((data, index) => {
            return {
                QUESTION_ID: data.QUESTION_ID,
                QUESTION: data.QUESTION,
                label: data.QUESTION
            }
        }) : [],
        question_list: [],
        search_key: false
    })


    useEffect(() => {
        debugger
        if (oppurtunityType === "INTERNSHIP") {
            setState((prevState) => ({
                ...prevState,
                selected_questions: [
                    ...(prevState.selected_questions || []),
                    {
                        QUESTION_ID: 25,
                        QUESTION: 'What is your available start date for the internship?',
                        label: 'What is your available start date for the internship?',
                    },
                    {
                        QUESTION_ID: 26,
                        QUESTION: 'What is the expected duration (in months) of your internship tenure?',
                        label: 'What is the expected duration (in months) of your internship tenure?',
                    },
                ],
            }));
        }

    }, [oppurtunityType]);
    const handleSubmit = () => {
        if (validateFunctionalForm(state, setState)) {

            const model = {
                IS_INCLUDE_WALK_IN: state.include_walk_in_distance ? "Y" : "N",
                WALK_IN_START_DATE: state.include_walk_in_distance ? state.walk_in_start_date.value : "",
                DURATION: state.include_walk_in_distance ? state.duration.value : "",
                WALK_IN_START_TIME: state.include_walk_in_distance ? state.walk_in_start_time.value : "",
                WALK_IN_END_TIME: state.include_walk_in_distance ? state.walk_in_end_time.value : "",
                CONTACT_PERSON: state.include_walk_in_distance ? state.contact_person.value : "",
                MOBILE_NUMBER: state.include_walk_in_distance ? state.mobile_number.value : "",
                VENUE: state.include_walk_in_distance ? state.venue.value : "",
                GOOGLE_MAP_URL: state.include_walk_in_distance ? state.google_map_url.value : "",
                QUESTIONS: state.selected_questions,
            };
            model.JOB_ID = detail.JOB_ID;
            onSubmit(model);
        }
    };

    const getJobQuestion = (input) => {
        jobQuestionList(input).then((res) => {
            if (res.status) {
                let d = res.result && res.result.map((data, index) => {
                    return {
                        QUESTION_ID: data.QUESTION_ID,
                        QUESTION: data.QUESTION,
                        label: data.QUESTION
                    }
                })
                setState((prevState) => ({
                    ...prevState,
                    question_list: d || [],
                    search_key: true
                }));
            }
        });

    }
    const handleChange = (e) => {
        const { name, value } = e.target;

        setState((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
            }
        }));
    };
    const handleCheckBox = (e) => {
        const isWalkIn = e.target.value === "in_person";

        // Update state to reflect the selected option

        setState((prevState) => ({
            ...prevState,
            include_walk_in_distance: isWalkIn,
            ['walk_in_start_date']: {
                ...prevState['walk_in_start_date'],
                isRequired: isWalkIn
            },
            ['venue']: {
                ...prevState['venue'],
                isRequired: isWalkIn
            },
            ['duration']: {
                ...prevState['duration'],
                isRequired: isWalkIn
            }
        }));
    };
    return (
        <React.Fragment>
            <div>
                <div className={`${styles['bgblue-ctm']} text-white`}>
                    <h5>Interview details</h5>
                    <p className="mb-0">Let candidates know how interview will be conducted for this job.</p>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card border-0 my-3 shadow-sm rounded-3'>
                            <div className='card-body p-2'>
                                <div className='row'>
                                    <div className="col-lg-12 column-lg-full">
                                        <div className="input-box">
                                            <label className={`${styles['ct-form-label']} form-label my-3`}>
                                                Type of Interview {' '}
                                                <span className="text-danger font-size-16">*</span>
                                            </label>
                                            <div className="d-flex flex-wrap gap-2">
                                                <ul className={`${styles['post-joblist']} d-flex`}>
                                                    <li>
                                                        <input
                                                            type="radio"
                                                            name="INCLUDE_WALK_IN_DISTANCE"
                                                            value="in_person"
                                                            checked={state.include_walk_in_distance}
                                                            onChange={handleCheckBox}
                                                        />
                                                        <div className="wfhheading">
                                                            In-Person / Walk-In Interview
                                                            <p>This job is for fresher candidates only.</p>
                                                        </div>
                                                    </li>

                                                    <li>
                                                        <input
                                                            type="radio"
                                                            name="INCLUDE_WALK_IN_DISTANCE"
                                                            value="online"
                                                            checked={!state.include_walk_in_distance}
                                                            onChange={handleCheckBox}
                                                        />
                                                        <div className="wfhheading">
                                                            Telephonic/Online Interview
                                                            <p>This job is for experienced candidates only.</p>
                                                        </div>
                                                    </li>
                                                </ul>

                                            </div>
                                        </div>
                                    </div>
                                    {state.include_walk_in_distance &&
                                        <div className="col-lg-12 column-lg-full pt-2">
                                            <div className="row">
                                                <div className="col-lg-4 mb-3">
                                                    <label className={`${styles['ct-form-label']} form-label`}>
                                                        Walk-in Start Date{" "}
                                                        <span className="text-danger font-size-16">
                                                            *
                                                        </span>
                                                    </label>
                                                    <div className="form-group">
                                                        <input
                                                            className={
                                                                state.walk_in_start_date.error.length >
                                                                    0
                                                                    ? "form-control is-invalid"
                                                                    : "form-control"
                                                            }
                                                            type="date"
                                                            name={state.walk_in_start_date.name}
                                                            value={state.walk_in_start_date.value}
                                                            onChange={handleChange}
                                                            min={moment().format("YYYY-MM-DD")}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-4">
                                                    <label className={`${styles['ct-form-label']} form-label`}>
                                                        Walk-in start timing
                                                    </label>
                                                    <div className="form-group ">
                                                        <input
                                                            className="form-control"
                                                            type="time"
                                                            placeholder="Choose start date"
                                                            name={state.walk_in_start_time.name}
                                                            value={state.walk_in_start_time.value}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <label className={`${styles['ct-form-label']} form-label`}>
                                                        Walk-in end timing
                                                    </label>
                                                    <div className="form-group ">
                                                        <input
                                                            className="form-control"
                                                            type="time"
                                                            placeholder="Choose start date"
                                                            name={state.walk_in_end_time.name}
                                                            value={state.walk_in_end_time.value}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 mb-3">
                                                    <label className={`${styles['ct-form-label']} form-label`}>
                                                        Duration (Days){" "}
                                                        {/* <span className="text-danger">*</span> */}
                                                    </label>
                                                    <div className="form-group">
                                                        <NumberFormat
                                                            className={
                                                                state.duration.error.length > 0
                                                                    ? "form-control is-invalid"
                                                                    : "form-control"
                                                            }
                                                            placeholder="Duration in days"
                                                            name={state.duration.name}
                                                            value={state.duration.value}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 column-lg-full">
                                                    <div className="input-box">
                                                        <label className={`${styles['ct-form-label']} form-label`}>
                                                            Contact Person
                                                        </label>
                                                        <div className="form-group">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                name={state.contact_person.name}
                                                                value={state.contact_person.value}
                                                                onChange={handleChange}
                                                                placeholder="Recruiter name(if available)"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 column-lg-full">
                                                    <div className="input-box">
                                                        <label className={`${styles['ct-form-label']} form-label`}>
                                                            Contact Number
                                                        </label>
                                                        <div className="form-group">
                                                            <NumberFormat
                                                                className="form-control"
                                                                name={state.mobile_number.name}
                                                                value={state.mobile_number.value}
                                                                onChange={handleChange}
                                                                placeholder="Add mobile number"
                                                                maxLength={10}
                                                                minLength={10}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 column-lg-full mb-3">
                                                    <div className="input-box">
                                                        <label className={`${styles['ct-form-label']} form-label`}>
                                                            Venue{" "}
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <div className="form-group">
                                                            <input
                                                                className={
                                                                    state.venue.error.length > 0
                                                                        ? "form-control is-invalid"
                                                                        : "form-control"
                                                                }
                                                                type="text"
                                                                name={state.venue.name}
                                                                value={state.venue.value}
                                                                onChange={handleChange}
                                                                placeholder="Type Address Here"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 column-lg-full">
                                                    <div className="input-box">
                                                        <label className={`${styles['ct-form-label']} form-label`}>
                                                            Google Map URL
                                                        </label>
                                                        <div className="form-group">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                name={state.google_map_url.name}
                                                                value={state.google_map_url.value}
                                                                onChange={handleChange}
                                                                placeholder="Google Map URL of venue"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="col-lg-12 column-lg-full pt-3">
                                        <div className="recruiterAskQ">
                                            <div className="askquetext">
                                                <h6>
                                                    Ask questions to candidates they should
                                                    respond to when they are applying
                                                </h6>
                                                <p>
                                                    Here are a few suggestions to get you
                                                    started
                                                </p>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12 column-lg-full">
                                                    <div className="input-box">
                                                        <label className={`${styles['ct-form-label']} form-label`}>
                                                            Add Questions
                                                        </label>



                                                        <div className="form-group">

                                                            <Multiselect
                                                                placeholder='Select Question'
                                                                style={{
                                                                    optionContainer:
                                                                        state.search_key ? { display: 'block' } : { display: 'none' }
                                                                }}
                                                                options={state.question_list}

                                                                onSelect={(selectedValue) => {
                                                                    debugger
                                                                    setState((prevState) => ({
                                                                        ...prevState,
                                                                        selected_questions: selectedValue
                                                                    }));
                                                                }}
                                                                onSearch={(e) => {
                                                                    getJobQuestion(e)
                                                                }
                                                                }
                                                                selectedValues={state.selected_questions}
                                                                displayValue={"QUESTION"}
                                                                name={"QUESTION_ID"}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-between mt-4">
                <button
                    className="btn btn-secondary"
                    onClick={prevStep}
                >
                    Previous
                </button>
                <button
                    className={`${styles['btn-next']} btn`}

                    onClick={handleSubmit}
                >
                    Next
                </button>
            </div>
        </React.Fragment>
    )
}

export default StepTwo